/* eslint-disable @babel/no-invalid-this */
const isFreeBraceletsCollectionPage = document.querySelector('.free-bracelets-collection-page');
const isBraceletsPlushesCollectionPage = document.querySelector('.bracelets-plushes-collection-page');
const isPWYWBraceletsCollectionPage = document.querySelector('.pwyw-bracelets-collection-page');

function BraceletsOverview() {
  const dropdowns = document.querySelectorAll('.dropdown-wrapper');

  function onProductOptionRadioClick(event) {
    const button = event.currentTarget;
    const variantId = button.dataset.variantid;
    const product = button.closest('.products-overview__product.--bracelets');
    const variantImage = product.querySelector(`.item.img-var-${variantId}`);
    const variantImages = product.querySelectorAll('.item');
    variantImages.forEach((image) => {
      image.classList.remove('is-active');
    });
    variantImage.classList.add('is-active');
    onUpdateCartButton(variantId, product);
    updatePricing(variantId, product);
    updateSelectButton(variantId, product);

    // Updates hidden variant selected input
    const selectForm = product.querySelector('.product-form__variants');
    const selectOptions = selectForm.querySelectorAll('option');
    selectOptions.forEach((option) => {
      if (option.value === variantId) {
        option.setAttribute('selected', 'selected');
      } else {
        option.removeAttribute('selected');
      }
    });
    // Updates variant buttons checked state
    const element = document.querySelector(`.single-option-selector__radio[data-variantid="${variantId}"]`);
    if (element) {
      element.checked = true;
    }
  }

  function onLoadFirstAvailableVariant() {
    const productItems = document.querySelectorAll('.products-overview__product.--bracelets');
    productItems.forEach((product) => {
      const variantImages = product.querySelectorAll('.item');
      // find index of first available variant image
      if (variantImages.length) {
        let firstAvailableVariantIndex = 0;
        let variantId = variantImages[firstAvailableVariantIndex].getAttribute('data-priveww');
        for (let i = 0; i < variantImages.length; i++) {
          const isVariantAvailable = variantImages[i].getAttribute('data-available') === 'true';
          if (isVariantAvailable) {
            firstAvailableVariantIndex = i;
            variantImages[i].classList.add('is-active');
            variantId = variantImages[i].getAttribute('data-priveww');
            break;
          }
        }

        if (firstAvailableVariantIndex === 0) {
          variantImages[firstAvailableVariantIndex].classList.add('is-active');
        }

        onUpdateCartButton(variantId, product);
        updatePricing(variantId, product);
      }
    });
  }

  function updatePricing(variantId, currentParent) {
    const priceElements = currentParent.querySelectorAll('.products-overview__price-item');
    const priceElement = currentParent.querySelector(`.products-overview__price-item[data-variantid="${variantId}"]`);
    priceElements.forEach((price) => {
      price.classList.remove('is-active');
    });
    priceElement.classList.add('is-active');
  }

  function onUpdateCartButton(variantId, currentParent) {
    const submitButton = currentParent.querySelector('.product-form__cart-submit');
    if (submitButton) {
      const submitButtonText = submitButton.querySelector('.add-to-cart-button__text');
      const submitButtonSoldOutText = submitButton.querySelector('.add-to-cart-button__text-sold-out');
      const isCurrentVariantSoldOut =
        document
          .querySelector(`.single-option-selector__radio[data-variantid="${variantId}"]`)
          .getAttribute('data-available') === 'false';

      if (isCurrentVariantSoldOut) {
        submitButton.setAttribute('aria-disabled', 'disabled');
        submitButton.setAttribute('disabled', 'disabled');
        submitButtonSoldOutText.removeAttribute('hidden');
        submitButtonText.setAttribute('hidden', true);
      } else {
        submitButtonText.removeAttribute('hidden');
        submitButtonSoldOutText.setAttribute('hidden', true);
        submitButton.removeAttribute('disabled');
        submitButton.removeAttribute('aria-disabled');
      }
    }
  }

  function updateSelectButton(variantId, currentParent) {
    const selectButton = currentParent.querySelector('.products-overview__select-button');
    if (selectButton) {
      // update href of select button to include variant id
      const href = selectButton.getAttribute('href');
      const newHref = `${href.split('?')[0]}?variant=${variantId}`;
      selectButton.setAttribute('href', newHref);
    }
  }

  function init() {
    if (dropdowns.length > 0 && window.innerWidth <= 768) {
      dropdowns.forEach((dropdown) => {
        dropdown.addEventListener('click', function () {
          dropdowns.forEach((element) => {
            if (element === dropdown) {
              return;
            }

            element.classList.remove('active');
            element.closest('.products-overview__grid-item').classList.remove('active');
            element.querySelector('.dropdown-menu').style.display = 'none';
          });
          this.setAttribute('tabindex', 1);
          this.classList.toggle('active');
          this.closest('.products-overview__grid-item').classList.add('active');
          const dropdownMenu = this.querySelector('.dropdown-menu');
          this.focus();
          dropdownMenu.style.display =
            dropdownMenu.style.display === 'none' || dropdownMenu.style.display === '' ? 'block' : 'none';
        });

        dropdown.addEventListener('blur', function () {
          this.classList.remove('active');
          this.closest('.products-overview__grid-item').classList.remove('active');
          const dropdownMenu = this.querySelector('.dropdown-menu');
          dropdownMenu.style.display = 'none';
        });

        const menuItems = dropdown.querySelectorAll('.dropdown-menu li');
        menuItems.forEach((menuItem) => {
          menuItem.addEventListener('click', function () {
            const dropdownParent = this.closest('.dropdown-wrapper');
            menuItems.forEach((element) => {
              element.classList.remove('active');
            });
            this.classList.add('active');
            dropdownParent.querySelector('span').textContent = this.textContent;
            dropdownParent.querySelector('img').src = this.getAttribute('data-icon');
            dropdownParent.querySelector('input').setAttribute('value', this.getAttribute('data-value'));

            const variantId = this.getAttribute('data-value');
            const product = this.closest('.products-overview__product');
            const variantImage = product.querySelector(`.item.img-var-${variantId}`);
            const variantImages = product.querySelectorAll('.item');
            variantImages.forEach((image) => {
              image.classList.remove('is-active');
            });
            variantImage.classList.add('is-active');
            onUpdateCartButton(variantId, product);
            updatePricing(variantId, product);
            updateSelectButton(variantId, product);

            // Updates hidden variant selected input
            const selectForm = product.querySelector('.product-form__variants');
            const selectOptions = selectForm.querySelectorAll('option');
            selectOptions.forEach((option) => {
              if (option.value === variantId) {
                option.setAttribute('selected', 'selected');
              } else {
                option.removeAttribute('selected');
              }
            });
            // Updates variant buttons checked state
            const element = document.querySelector(`.single-option-selector__radio[data-variantid="${variantId}"]`);
            if (element) {
              element.checked = true;
            }
          });
        });
      });
    }

    // On Radio Button change update current active image to show selected variant
    const productOptionRadios = document.querySelectorAll('.single-option-selector__radio');
    productOptionRadios.forEach((radio) => {
      radio.addEventListener('click', onProductOptionRadioClick);
    });

    onLoadFirstAvailableVariant();
  }

  if (
    document.body.classList.contains('bracelets-overview') ||
    isFreeBraceletsCollectionPage ||
    isBraceletsPlushesCollectionPage ||
    isPWYWBraceletsCollectionPage
  ) {
    init();
  }
}

if (
  document.body.classList.contains('bracelets-overview') ||
  isFreeBraceletsCollectionPage ||
  isBraceletsPlushesCollectionPage ||
  isPWYWBraceletsCollectionPage
) {
  BraceletsOverview();
}
